import { render, staticRenderFns } from "./userInfoBox.vue?vue&type=template&id=0fcef941&"
import script from "./userInfoBox.vue?vue&type=script&lang=ts&"
export * from "./userInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports